<template>
    <div class="row mb-3 repeater-row" :class="'repeater-row-'+documentIndex">
        <div class="col-xl mb-3">
            <label class="m-show-xl">Type</label>
            <v-select :options="documentTypes"
                      v-model="document.type"
                      v-if="renderedComponent"
                      label="name"
                      :selectOnTab="true"
            >
                <div slot="no-options">Voeg document type toe</div>
            </v-select>
        </div>
        <div class="col-xl mb-3">
            <label class="m-show-xl">Naam</label>
            <input type="text"
                   class="form-control"
                   v-model="document.name"
            >
        </div>
        <div class="col-xl mb-3">
            <label class="m-show-xl">Bestand</label>
            <file-select v-model="document.file"></file-select>
        </div>
        <div class="repeat-row-actions">
            <i v-if="documentIndex !== 0" class="far fa-trash-alt" @click="removeDocumentRow(documentIndex)"></i>
        </div>
    </div>
</template>

<script>
    import fileSelect from './fileSelect';

    export default {
        inject: ['$validator'],
        components: {
            fileSelect
        },
        props: {
            value: File,
            document: Object,
            documentIndex: Number,
            renderedComponent: Boolean
        },
        data() {
            return {
                documents: [],
                documentTypes: ['ID', 'Certificaat', 'Contract', 'Overig'],
                fileName: null,
            }
        },
        methods: {
            removeDocumentRow(documentIndex) {
                this.$emit('documentRemoved', documentIndex)
            }
        }
    }
</script>